import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import HackerOneConfigListing from './HackerOneConfigListing'
import HackerOneCredentialsForm from './HackerOneCredentialsForm'

export default function HackerOnePullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={HackerOneCredentialsForm}
            PullConfigListingView={HackerOneConfigListing}
        />
    )
}
